import api from './api';

export const transactionService = {
  /**
   * Listar transações com filtros
   */
  getAll: async (params = {}) => {
    const response = await api.get('/transactions', { params });
    return response;
  },

  /**
   * Buscar transação por ID
   */
  getById: async (transactionId, date) => {
    const response = await api.get(`/transactions/${transactionId}`, {
      params: { date },
    });
    return response;
  },

  /**
   * Criar nova transação
   */
  create: async (data) => {
    const response = await api.post('/transactions', data);
    return response;
  },

  /**
   * Atualizar transação
   */
  update: async (transactionId, date, data) => {
    const response = await api.put(`/transactions/${transactionId}`, data, {
      params: { date },
    });
    return response;
  },

  /**
   * Excluir transação
   */
  delete: async (transactionId, date) => {
    const response = await api.delete(`/transactions/${transactionId}`, {
      params: { date },
    });
    return response;
  },

  /**
   * Buscar transações por conta
   */
  getByAccount: async (accountId, params = {}) => {
    const response = await api.get(`/transactions/account/${accountId}`, { params });
    return response;
  },

  /**
   * Buscar transações por categoria
   */
  getByCategory: async (categoryId, params = {}) => {
    const response = await api.get(`/transactions/category/${categoryId}`, { params });
    return response;
  },

  /**
   * Importar transações em lote (OFX, CSV)
   */
  importTransactions: async (transactions, accountId) => {
    const response = await api.post('/transactions/import', { transactions, accountId });
    return response;
  },
};

export default transactionService;
